<template>
  <div>
    <p class="titleModal">
      {{ $t(`technicalFile.boiler.step1.title`) }}
    </p>
    <v-row>
      <v-col class="noYPadding">
        <VTextField
          v-model="data.identifier"
          :label="$t('technicalFile.boiler.step1.identifier')"
          :rules="{ required: false, min: 1, max: 200 }"
          class="text-field-transparent"
          :readonly="readonly"
          outlined
          flat
          data-cy="systemSpecifications-identifier"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="noYPadding">
        <VTextField
          v-model="data.manufacturer"
          :label="$t('technicalFile.boiler.step1.manufacturer')"
          class="text-field-transparent"
          outlined
          :readonly="readonly"
          flat
          data-cy="systemSpecifications-manufacturer"

          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        sm="6"
        class="noYPadding"
      >
        <VSelect
          v-model="data.systemType.value"
          :label="$t('technicalFile.boiler.step1.type')"
          :items="translatedBoilerTypes"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          data-cy="boilerType"
          @input="updateData"
        />
      </v-col>
      <v-col
        class="noYPadding"
        cols="12"
        sm="6"
      >
        <VTextField
          v-model="data.systemType.option"
          :label="$t('technicalFile.boiler.step1.typeOption')"
          min="0"
          class="text-field-transparent"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        class="noYPadding"
        cols="12"
        sm="6"
      >
        <VTextField
          v-model="data.capacity.value"
          :label="$t('technicalFile.boiler.step1.capacity')"
          :formatNumber="true"
          type="number"
          min="0"
          class="text-field-transparent"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
        class="noYPadding"
      >
        <VSelect
          v-model="data.capacity.units"
          :label="$t('technicalFile.boiler.step1.units')"
          :items="displayedUnits('genericPower')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          data-cy="boilerCapacity"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        class="noYPadding"
        cols="6"
        sm="6"
      >
        <VTextField
          v-model="data.pressure.value"
          :label="$t('technicalFile.boiler.step1.pressure')"
          :formatNumber="true"
          type="number"
          min="0"
          class="text-field-transparent"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
        class="noYPadding"
      >
        <VSelect
          v-model="data.pressure.units"
          :label="$t('technicalFile.boiler.step1.units')"
          :items="displayedUnits('genericPressure')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          data-cy="genericPressure"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        class="noYPadding"
        cols="12"
        sm="6"
      >
        <VTextField
          v-model="data.volumeDuringOperation.value"
          :label="$t('technicalFile.boiler.step1.operationVolume')"
          :formatNumber="true"
          type="number"
          min="0"
          class="text-field-transparent"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
        class="noYPadding"
      >
        <VSelect
          v-model="data.volumeDuringOperation.units"
          :label="$t('technicalFile.boiler.step1.units')"
          :items="displayedUnits('genericVolumes')"
          class="text-field-transparent"
          itemValue="key"
          itemText="name"
          outlined
          :readonly="readonly"
          flat
          data-cy="genericVolumes"
          @input="updateData"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import { cloneDeep } from 'lodash';
import { mapGetters } from 'vuex';

export default {
    name: 'NetworkIdentification',
    components: {
        VTextField,
    },
    props: {
        systemSpecifications: {
            type: Object,
            default: () => {},
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            data: {
                identifier: '',
                manufacturer: '',
                capacity: {},
                systemType: {},
                pressure: {},
                volumeDuringOperation: {},
            },
        };
    },
    computed: {
        ...mapGetters([
            'units',
        ]),
        translatedBoilerTypes() {
            const boilerTypes = this.displayedUnits('boilerType');
            return boilerTypes.map(type => ({
                ...type,
                name: type.name,
            }));
        },
    },
    watch: {
        systemSpecifications: {
            handler() {
                this.data = { ...this.data, ...cloneDeep(this.systemSpecifications) };
            },
            immediate: true,
        },
    },
    methods: {
        updateData() {
            this.$emit('sendData', { systemSpecifications: this.data });
        },
        displayedUnits(type) {
            return this.units && this.units[type] ? this.units[type] : [];
        },
    },
};
</script>
<style lang="scss" scoped>
.noYPadding {
  padding-bottom: 0;
  padding-top: 0;
}
</style>
